import { AbstractPmsApiService } from "./abstract.service";
import { ShomoosApiLog } from "../models";

/**
 * @class ShomoosApiLogPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ShomoosApiLog>}
 */
export class ShomoosApiLogPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/shomoos-api-log(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ShomoosApiLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ShomoosApiLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ShomoosApiLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property=} property
     * @param {ShomoosApiLog=} log
     * @returns {Promise.<Boolean>}
     */
    resend(property, log) {

        const url = this.url({
            propertyId: property.id,
            id: log.id,
        });

        return this.http
            .get(url + '/resend', {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/shomoos-api-log.service.js